export const CACHED_COMMON_DATA_KEY = "cachedData";
export const CACHED_PICKLISTS_KEY = "cachedPicklists";
export const CACHED_NEEDS_ASSESSMENTS_SEARCH_YEARS = "naSearchYears";
export const CACHE_TIMEOUT_SEC = 600;
